<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body" v-if="!loading">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-70 md-xsmall-size-100 md-size-70 p-0">
            <h4>Prospect Lists</h4>
          </div>

          <div class="md-layout-item md-xsmall-size-30 md-size-30 button-box">
            <md-button class="md-info csv_btn access-button" v-on:click="downloadCSVData">
              <md-icon class="ml-5">receipt_long</md-icon>Download CSV
            </md-button>
          </div>

        </div>
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">

          </div>
        </div>
      </div>

      <div class="md-layout-item md-size-100 p-0">
        <md-card class="if_card">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header>
                <!-- <h1 class="md-title text-left profile-title"> -->
                Companies
                <!-- </h1> -->
              </md-card-header>
            </div>
          </div>
          <md-card-content>
            <div class="md-card px-4">
              <div class="md-layout industry_map">
                <div class="md-layout-item md-medium-size-100 md-size-35 p-0">
                  <ul class="favorite-list companis-list-tabl competitors-list">
                    <!-- <li class="map-content">
                    <pulse-loader
                        :color="'blue'"
                        :loading="loading"
                    ></pulse-loader>
                    </li>-->
                    <li class="favorite-list-item map-content p-0">
                      <collapse
                        idPrefix="mapHref_"
                        v-if="companyNames"
                        :collapse="companyNames"
                        icon="keyboard_arrow_down"
                        color-collapse="info"
                        value="left"
                        class="map-markers"
                        :active="false"
                        @setMarker="setMarker"
                      >
                        <template
                          v-for="(company, index) in companyListShow"
                          :slot="`md-collapse-pane-${index + 1}`"
                        >
                          <div :key="index">
                            <div class="md-card-content" md-alignment="left">
                              <span class="md-subheading">
                                {{
                                  company.businessName
                                }}
                              </span>
                              <div>
                                <small>
                                  {{
                                    `${company.zip4 ? company.zip4 + "," : ""} ${company.city
                                      }, ${company.locAddress
                                        ? company.locAddress + ","
                                        : ""
                                      } ${company.state ? company.state : ""}, ${company.zip ? company.zip : ""
                                      }`
                                  }}
                                  <br
                                    v-if="
                                      company.contactFirst || company.contactLast
                                    "
                                  />
                                  <b>
                                    {{
                                      `${company.contactTitle
                                        ? company.contactFirst ||
                                          company.contactLast
                                          ? company.contactTitle + ": "
                                          : ""
                                        : company.contactFirst ||
                                          company.contactLast
                                          ? "Contact:"
                                          : ""
                                        }`
                                    }}
                                  </b>
                                  <span
                                    v-if="
                                      company.contactFirst || company.contactLast
                                    "
                                  >
                                    {{
                                      `${company.contactFirst
                                        ? company.contactFirst
                                        : ""
                                        } ${company.contactLast
                                          ? company.contactLast
                                          : ""
                                        }`
                                    }}
                                  </span>
                                  <br />
                                  <b v-if="company.phonePrimary">Phone:</b>
                                  {{
                                    company.phonePrimary
                                      ? company.phonePrimary
                                      : ""
                                  }}
                                  <br />
                                  <b v-if="company.url">URL:</b>
                                  {{ company.url ? company.url : "" }}
                                </small>
                              </div>
                              <div>
                                <small>
                                  <b v-if="company.mailAddress">Mailing Address:</b>
                                  {{
                                    company.mailAddress ? company.mailAddress : ""
                                  }}
                                </small>
                              </div>
                              <div>
                                <small>
                                  <b>Industry:</b>
                                  {{ `[${bznaics}] ${industry}` }}
                                </small>
                              </div>
                              <div>
                                <small>
                                  <b v-if="company.sales">Estimated Sales:</b>
                                  {{ company.sales ? company.sales : "" }}
                                  <br />
                                  <b v-if="company.locationEmp">Estimated Employment:</b>
                                  {{
                                    company.locationEmp
                                      ? company.locationEmp
                                      : ""
                                  }}
                                  <br />
                                  <b v-if="company.earningsMedian">Earnings Approach Median Value:</b>
                                  {{
                                    company.earningsMedian
                                      ? company.earningsMedian
                                      : ""
                                  }}
                                  <br />
                                  <b v-if="company.creditNetScore">Credit.net Score:</b>
                                  {{
                                    company.creditNetScore
                                      ? company.creditNetScore
                                      : ""
                                  }}
                                  <!-- <span class="md-layout"> -->
                                  <!-- <span
                                      class="md-layout-item md-medium-size-100 md-size-50"
                                  ></span>-->
                                  <!-- <div class="md-layout-item md-medium-size-100 md-size-50 p-0">
                                    <md-button
                                      @click="
                                        createAndRedirect(
                                          company.locnum,
                                          company.zip,
                                          $event
                                        )
                                      "
                                      class="md-dense md-info md-block access-button"
                                    >Company Profile</md-button>
                                  </div>
                                  </span>-->
                                </small>
                              </div>
                            </div>
                          </div>
                        </template>
                      </collapse>
                    </li>
                    <li class="map-content">
                      <div class="pt-4 flex_content">
                        {{ numberWithCommas(pagination.total) }}
                        Companies
                      </div>
                    </li>
                    <li class="map-content">
                      <div class="flex_content">
                        <div v-show="!loading" class="pagin-page-info pagination-font">
                          Showing page:
                          {{ pagination.currentPage }}
                          of
                          {{ Math.ceil(pagination.total / pagination.perPage) }}
                        </div>
                        <div v-show="!loading" class="md-toolbar-section-end">
                          <pagination
                            class="pagination-no-border pagination-info"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="pagination.total"
                            @click.native="getPage()"
                          ></pagination>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="md-layout-item md-medium-size-100 md-size-65 p-0 md-medium-order-1">
                  <div
                    class="md-card-content competitors-map border-0"
                    md-alignment="left"
                    :key="mapKey"
                  >
                    <google-map-loader
                      v-if="mapCenter != null"
                      ref="mapRef"
                      :locations="companyCoordinates"
                      :center="mapCenter"
                    />
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { Collapse, PulseLoader } from "@/components";
import GoogleMapLoader from "@/pages/Dashboard/Components/GoogleMapLoader";
import { Pagination } from "@/components";
import { mapActions, mapState } from "vuex";
//import companyList from "../../../../store/modules/company-list-module";

export default {
  name: "company-list",
  components: {
   // PulseLoader,
    Pagination,
    Collapse,
    GoogleMapLoader,
  },
  props: ['companyListdata'],
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        total: undefined,
      },
      pageStart: 0,
      pageEnd: 50,
      mapData: [],
      mapCenter: null,
      industry: null,
      bznaics: null,
      loading: true,
      mapKey: 0,
      countCompany: 0,
      releaseDate: null,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      filtered_company_list: [],
    };
  },

  methods: {
    ...mapActions({
      auth_user: (state) => state.user,
      registerProductExport: 'tracking/registerProductExport',
    }),
    numberWithCommas: function (number) {
      if (number)
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return '';
    },
    createAndRedirect: async function (id, zip, event) {
      event.stopPropagation();
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/create/companyProfile",
          {},
          {
            params: {
              session_id: currentSession,
              locnum: id,
              zip: zip,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/create/companyProfile" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          const { id: reportId } = res.data;
          this.$router.push({
            name: "CompanyProfile",
            params: { id: reportId },
          });
        });
    },
    getPage() {
      if (this.pagination.currentPage == 1) {
        this.pageStart = 0;
        this.pageEnd = 50;
      } else {
        this.pageEnd = 50 * this.pagination.currentPage;
        this.pageStart = this.pageEnd - 50;
      }
      this.mapKey++;
    },
    setMarker(index) {
      let markers = this.$refs.mapRef.markers;
      let marker = markers[index - 1];
      this.$refs.mapRef.BounceMarker(marker, 750);
      this.$refs.mapRef.infowindow.setContent(marker.info);
      this.$refs.mapRef.infowindow.open(marker.getMap(), marker);
    },
    getCompanyList: async function () {
      this.$store.commit("SET_CURRENT_ID_NO_ACTION", this.id);
      this.loading = false;
      let res=this.companyListdata;


      /*await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/list/company",
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.id,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/list/company" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          if (res.data.error == false) {

            const { bznaics, industry, list } = res.data.data.data;
            this.bznaics = bznaics;
            this.industry = industry;
            this.$store.commit("SET_COMPANY_LIST_NO_ACTION", list);

            this.initializeMap();
            this.releaseDate = new Date(res.data.release_display);
            this.pagination.total = this.companyListLength;
            this.loading = false;
            this.mapKey++;
          } else {
            if (res.data.errorCode === "report_wrong_user") {
              this.$router.push({ name: "Search" });
            }
          }
        });*/


         if (res.data.error == false) {
            const { bznaics, industry, list } = res.data.data.data;
            this.bznaics = bznaics;
            this.industry = industry;
            this.$store.commit("SET_COMPANY_LIST_NO_ACTION", list);

            this.initializeMap();
            this.releaseDate = new Date(res.data.release_display);
            this.pagination.total = this.companyListLength;
            this.loading = false;
            this.mapKey++;
          } else {
            if (res.data.errorCode === "report_wrong_user") {
              this.$router.push({ name: "Search" });
            }
          }
    },

    initializeMap: function () {
      this.mapCenter = {
        zoom: 11,
        lon: this.companyListShow[0].longitude,
        lat: this.companyListShow[0].latitude,
      };
      this.pagination.total = this.companyListLength;
    },
    removeCommas(string2){
      if(string2.length>0)
        return parseFloat(string2.replace(/,/g, ''))
      else
        return string2;
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Company List.csv';
      anchor.click();
      this.registerProductExport({
          userId: this.auth_user?.user?.userID,
          productId: this.$route.params.id,
          exportType: 'CSV'
      })
    },
  },
  async mounted() {
    if (this.id !== this.currentId) {
      this.$store.commit("SET_COMPANY_SUMMARY_NO_ACTION", null);
      this.$store.commit("SET_COMPANY_LIST_NO_ACTION", null);
      await this.getCompanyList();
    }
    else {
      this.initializeMap();
    }
    let me = this;
    let filteredCompany = [];
    // Each row is built defensively (try/catch) so one malformed company can't blank the
    // whole CSV export -- see the locnum removal below for how that happened for real.
    this.companyList.forEach((el, i) => {
      try {
        let a = {};
        // locnum (the data-axle/InfoGroup id) is deliberately no longer sent by the backend
        // (CompanyController::getData, "7.18 feedback #6" -- must never leave in the customer
        // deliverable), so it must not be read here either. Reading el.locnum.toExponential(4)
        // on the now-missing field threw on the very first row and silently emptied this whole
        // list -- companyListShow (the on-screen table) never touched locnum, so only the CSV
        // export went blank.
        a.sales = el.sales
        a.businessName = el.businessName
        a.industryCode = me.industry_code
        a.industryName = me.industry_name
        a.locationAddress = el.locAddress
        a.suite = el.suite
        a.city = el.city
        a.zip = el.zip
        a.zip4 = el.zip4
        a.stateAbbrevation = el.state
        a.mailAddress = el.mailAddress
        a.mailAddressCity = el.mailAddressCity
        a.mailAddressState = el.mailAddressState
        a.mailAddressZip = el.mailAddressZip
        a.phonePrimary = el.phonePrimary
        a.contactFirst = el.contactFirst
        a.contactLast = el.contactLast
        a.contactTitle = el.contactTitle
        a.locationEmp = el.locationEmp
        a.url = el.url
        a.earningsMedian = el.earningsMedian
        a.creditNetScore = el.creditNetScore
        filteredCompany.push(a);
      } catch (e) {
        console.error('CompanyList: skipping a company that failed to map for CSV export', i, e);
      }
    })
    filteredCompany.forEach(item => {
      if (typeof item.businessName === 'string' && item.businessName.includes(',')) {
        item.businessName = item.businessName.replace(/,/g, '');
      }
      if (typeof item.earningsMedian === 'string' && item.earningsMedian.includes(',')) {
        item.earningsMedian = item.earningsMedian.replace(/,/g, '.');
      }
    })
    filteredCompany.forEach((element) => {
      this.filtered_company_list.push(Object.values(element));
    })
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
    }),
    psTotalResult() {
      return this.$store.getters.psTotalResult ?? this.$store.getters.companyListNoAction.length;
    },
    id() {
      return this.$route.params.id;
    },
    industry_code() {
      return this.bznaics ? this.bznaics : null;
    },
    industry_name() {
      return this.industry ? this.industry : null;
    },
    currentId() {
      return this.$store.getters.currentId;
    },
    companyList() {
      return this.$store.getters.companyListNoAction ?
        this.$store.getters.companyListNoAction.filter(x => x.latitude !== null && x.longitude !== null).slice(0, this.removeCommas(this.psTotalResult))
        : null;

       /*  return this.$store.getters.companyListNoAction ?
        this.$store.getters.companyListNoAction.filter(x => x.latitude !== null && x.longitude !== null).slice(0, this.psTotalResult)
        : null;
        */
    },
    companyListLength() {
      return this.companyList.length;
    },
    companyNames() {
      return this.companyListShow
        ? this.companyListShow.map(
          (item, index) => `#${index + 1} ` + item.businessName
        )
        : null;
    },
    companyListShow() {
      return this.companyList
        ? this.companyList.slice(this.pageStart, this.pageEnd)
        : [];
    },
    companyCoordinates() {
      return this.companyListShow
        ? this.companyListShow.map(function (item, index) {
          return {
            CONAME: item.businessName,
            lat: item.latitude,
            lng: item.longitude,
          };
        })
        : null;
    },
    getCsvData() {
      let csvData = [
        [
          'Estimated Sales', 'Business Name', 'Industry Code', 'Industry Name', 'Location Address', 'Suite', 'City', 'Zip', 'Zip+4',
          'State Abbreviation', 'Mailing Address', 'Mailing Address City', 'Mailing Address State', 'Mailing Address Zip', 'Primary Phone Number',
          'Contact First Name', 'Contact Last Name', 'Contact Title', 'Location Employment', 'URL', 'Earnings Approach Median Value', 'Credit.net Score'
        ],
      ]
      this.filtered_company_list.forEach((e, i) => {
        csvData.push(e);
      });
      return csvData;
    },
  }
}
  ;
</script>

<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.company-name {
  color: #3c4858;
  cursor: pointer;
  transition: 0.5s;
}

.company-name:hover {
  color: #1a7bfa;
  transition: 0.5s;
}

.company-list-title {
  margin: 0 !important;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.if-profile-body {
  .companis-list-tabl {
    .favorite-list-item {
      .list-item-head {
        align-items: center;
      }
    }
  }
}

.competitors-list {
  .md-collapse-title {
    font-size: 12px;
    font-weight: 300;
    margin-left: 25px;
  }

  .md-icon {
    font-size: 12px;
    font-weight: 300;
    transform: rotate(-90deg);
    left: 0;
    color: rgba(0, 0, 0, 0.54);
  }
}

.competitors-map {
  iframe {
    height: 500px !important;
  }
}

.map-content {
  .md-collapse-label {
    padding: 0;
  }
}

.pagination-font {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.5em;
}
</style>
